import validationRules from "../validationRules";
validationRules.register("hexadecimal", function (record, fieldMetadataMap, fieldName, t) {
    var hexadecimal = record[fieldName] || "";
    var result = /[0-9A-Fa-f]{6}/g.test(hexadecimal);
    if (result) {
        return true;
    }
    return "should be hexadecimal.";
});
